import { BaseException } from '@/data/exceptions/BaseException'

export abstract class BaseExceptionApi extends BaseException {
  constructor(name: string, code: TypeExceptionCodeApi, message = '') {
    super(name, code, message)
  }
}
